import { render, staticRenderFns } from "./DoubleBounce.vue?vue&type=template&id=23612bca&scoped=true"
import script from "./DoubleBounce.vue?vue&type=script&lang=js"
export * from "./DoubleBounce.vue?vue&type=script&lang=js"
import style0 from "./DoubleBounce.vue?vue&type=style&index=0&id=23612bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23612bca",
  null
  
)

export default component.exports